/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartsRecommenderWrapperAPI
 * @hideconstructor
 *
 * @classdesc
 */
define([], () => {
	class SmartsRecommenderWrapperAPI {
		recommendBindingsForNewColumns() {}
		recommendBindingsForSelectedViz() {}
		recommendBestAlternateVisualization() {}
		recommendAlternateVisualizations() {}
		recommendRelatedVisualizations() {}
		recommendCompareVisualizations() {}
		getRecommendInfo() {}
		getSmartsToVizMappingsForVisId() {} //Returns mappings from Smarts known elements to bundle elements per vis id.
		isVisSlotKnownToSmarts() {}
		/* SmartsRecommender is overreaching in transformRecommendationsToLiveWidgetSpecs */
		_transformRecommendationResponse() {}
	}

	return SmartsRecommenderWrapperAPI;
});
